export const computePowerScalePercent = (
    value: number | null | undefined,
    minPower: number | null | undefined,
    maxPower: number | null | undefined
): number | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (value < 0) {
        if (minPower === null || minPower === undefined || minPower === 0) {
            return undefined;
        }
        return -(Math.abs(value) / Math.abs(minPower)) * 100;
    }
    if (value > 0) {
        if (maxPower === null || maxPower === undefined || maxPower === 0) {
            return undefined;
        }
        return (value / maxPower) * 100;
    }
    return 0;
};
